import { IPolicy } from 'modules/settings/models';
import API from 'services/api';

export const getCancellationPolicies = (partnerId: number): Promise<IPolicy[]> => {
  return API.get(`/api/accommodation/cancellation-policy?partnerId=${partnerId}`).then(
    res => res?.data,
  );
};
